<template>
  <div class="app-shell">
    <div class="container">
      <!-- popups -->
      <IFrameWarningToast />
      <ContentUpdateToast />

      <div class="three-column-layout">
        <div>
          <!-- sidebar ad left -->
          <sb-left-ad></sb-left-ad>
        </div>

        <main class="page-main">
          <!-- header -->
          <div class="sticky-header-wrapper">
            <AppHeader ref="appHeader" />
          </div>

          <!-- main page content from child routes -->
          <div class="page-inner">
            <router-view />

            <!-- footer -->
            <AppFooter />
          </div>
        </main>
        <div>
          <!-- sidebar ad right -->
          <sb-right-ad></sb-right-ad>
        </div>
      </div>

      <!-- mobile adhesive ad -->
      <mobile-adhesive-ad></mobile-adhesive-ad>
    </div>
  </div>
</template>

<script>
  import IFrameWarningToast from './toasts/IFrameWarningToast.vue';
  import ContentUpdateToast from './toasts/contentUpdateToast.vue';
  import AppFooter from './AppFooter.vue';
  import AppHeader from './header/AppHeader.vue';
  import SbLeftAd from './ads/sbLeftAd.vue';
  import SbRightAd from './ads/sbRightAd.vue';
  import MobileAdhesiveAd from './ads/mobileAdhesiveAd.vue';

  export default {
    components: {
      SbLeftAd,
      SbRightAd,
      MobileAdhesiveAd,
      ContentUpdateToast,
      IFrameWarningToast,
      AppFooter,
      AppHeader,
    },
    methods: {
      showAccountPopup() {
        this.$refs.appHeader?.showAccountPopup();
      },
      openCategoryAtlas(categoryId) {
        // Call the AppHeader method to show category popup with the specific category
        this.$refs.appHeader?.showCategoryInfoPopupWithCategory(categoryId);
      },
    },
    provide() {
      return {
        openCategoryAtlas: this.openCategoryAtlas,
      };
    },
  };
</script>

<style scoped>
  .three-column-layout {
    display: flex;
    background-color: rgb(35, 35, 48, 1);
    justify-content: center;
    flex: 1;
  }

  .app-shell {
    min-height: 100vh;
    background-color: rgba(42, 42, 58, 1);
    display: flex;
    flex-direction: column;
  }

  .sticky-header-wrapper {
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .page-main {
    flex: 0 1 1500px;
    max-width: 100%;
    background-color: rgb(53, 53, 72);
    box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  }

  .page-inner {
    position: relative;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
  }

  .container {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
  }
</style>
